import React, { useEffect, useRef, useState } from "react";
import Modal from "react-responsive-modal";
import { useDispatch } from "react-redux";
import { Descriptions } from "antd";
import { callApi } from "../../config/apiCall";
import { toast } from "react-toastify";
import { getAdminTicketData } from "../../redux/actions/adminAction";

const TicketResolveRemark = ({ open, onClose, user }) => {
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {};
    const [isLoading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        remark: "",
        // created_by: userDetails?.user?.id
    });

    const dispatch = useDispatch();
    const onchange = (e) => {
        const { name, value, type } = e.target
        setFormData((prev) => ({
            ...prev,
            [name]: type == "file" ? e.target.files : value
        }))
    };
    const handleSubmit = async (e) => {
        // e.preventDefault()
        try {
            setLoading(true)
            const data = {status:open?.statusValue,"remark":formData?.remark}
            // new FormData()
            // data.append("status ", open?.statusValue)
            // data.append("remark", formData?.remark)
            const response = await callApi(`tickets/${open?.rowData?.id}`, "POST", data, userDetails?.token)
            console.log(response);
            setLoading(false)
            if(!response?.valid || !response.authenticated){
                toast.error(response?.mssg[0])
                return
            }
            if (response?.success) {
                onClose();
                toast.success(response?.mssg)
                dispatch(getAdminTicketData())
                setFormData({
                    remark:""
                })
            } else {
                toast.error(response?.mssg ||response?.mssg[0])
            }

        } catch (error) {
            setLoading(false)
            console.log(error);
            toast.error(error?.response?.data?.message || error?.message)

        }

    };


    return (
        <Modal
            open={open}
            onClose={onClose}
            center
            showCloseIcon={false}
            closeOnOverlayClick={false}
            classNames={{ modal: "custom-modal1322" }}
        >
            <form onSubmit={handleSubmit} className="wfh-container">
                <h2 className="wfh-title">
                    Resolve Description
                </h2>
                <p className="wfh-subtitle">
                    You can share any concern or seek help from your organization
                </p>
                <div className="input-group">
                    <label className="input-label">Remark</label>
                    <textarea
                        className="input-field textarea"
                        placeholder="Please share which you have resolved"
                        value={formData?.remark}
                        name="remark"
                        required
                        onChange={onchange}
                    />
                </div>
                <div className="button-group">
                    <button
                        type="button"
                        className="btn cancel"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn submit"
                        onClick={() => {
                            if (!isLoading) {
                                handleSubmit();
                            }
                        }}
                    >
                        {
                            isLoading ? "Loading ..." : "Resolve"
                        }
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default TicketResolveRemark;
